<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		created() {
			function flash() {
				szblMCom.getRefreshToken()
				setTimeout(() => {
					flash()
				}, 60000 * 60)
			}
			flash()
		},
	}
</script>

<style lang="scss">
	* {
		margin: 0;
		padding: 0;
	}
	p {
		text-indent: 2em;
	}
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		// color: white;
	}
	.amap-marker-label,
	.amap-overlay-text-container {
		border: 0;
		background-color: transparent;
		color: white;
	}
	.amap-marker-label {
		color: #000;
	}
	.title-name-y {
		font-size: 18px;
		font-weight: 600;
		color: #34faff;
		line-height: 32px;
		border-bottom: 1px solid #bdbdbd;
	}
	.tdt-infowindow-tip-container {
		display: none;
	}
	.t-iten {
		line-height: 24px;
		color: #fff;
		margin-top: 8px;
		font-size: 14px;
		// display: flex;
		// justify-items: center;
		// align-items: center;
		// width: 120px;
	}
	.click {
		cursor: pointer;
	}
	.t-iten-remark {
		// text-indent: 2em;
		color: #fff;
		text-align: center;
		.mess {
			// text-align: start;
		}
	}

	.t-iten span {
		display: inline-block;
		// width: 112px;
		color: #34faff;
	}
	.t-iten img {
		width: 120px;
		height: 120px;
		border: 1px solid #34faff;
	}
	.tdt-infowindow-content-wrapper {
		background-color: #0e243cb5 !important;
		background-image: url(./assets/img/outlistbg.png) !important;
		background-repeat: no-repeat !important;
		background-size: 100% 100% !important;
		color: #62fdff !important;
		width: 400px;
		max-height: 50vh;
		overflow-y: scroll;
		&::-webkit-scrollbar {
			width: 10px;
			height: 10px;
		}
		&::-webkit-scrollbar-corner {
			box-shadow: inset 0 0 5px rgba($color: #408ba5, $alpha: 0.6);
			background-color: rgba($color: #408ba5, $alpha: 0.6);
		}
		&::-webkit-scrollbar-track {
			box-shadow: inset 0 0 5px rgba($color: #408ba5, $alpha: 0.6);
		}
		&::-webkit-scrollbar-thumb {
			background-color: rgba($color: #408ba5, $alpha: 0.6);
			border-radius: 10px;
		}
	}
	.amap-info-close {
		font-size: 32px;
		color: #fff;
		font-weight: 100;
		right: 18px;
		top: 12px;
	}
	.bottom-center .amap-info-sharp {
		border-top: 8px solid #1c4056c7;
	}
	.newcount::after {
		width: 120px;
		height: 240px;
		background-color: #bdbdbd;
	}
	.lsyh {
		font-size: 14px;
		text-decoration: underline;
	}
	$white-color: #358fe6;
	$white-bg-color: #fff;
	$white-text-color: #333;
	$white-fz-color: #999;
	.whiteColor {
		.amap-marker-label,
		.amap-overlay-text-container {
			border: 0;
			background-color: transparent;
			color: $white-text-color;
		}
		.amap-marker-label {
			color: $white-text-color;
		}
		.title-name-y {
			font-size: 18px;
			font-weight: 600;
			color: $white-text-color;
			line-height: 32px;
			border-bottom: 1px solid #bdbdbd;
		}
		.t-iten {
			line-height: 24px;
			color: $white-text-color;
			margin-top: 8px;
		}
		.t-iten-remark {
			text-indent: 2em;
			color: $white-text-color;
		}
		.t-iten span {
			display: inline-block;
			// width: 112px;
			color: $white-text-color;
		}
		.t-iten img {
			width: 120px;
			height: 120px;
			border: 1px solid $white-fz-color;
		}
		.tdt-infowindow-content-wrapper {
			width: 400px;
			color: $white-text-color !important;
		}
		.tdt-infowindow-content-wrapper {
			background-color: $white-bg-color !important;
			background-image: none !important;
			// background-repeat: no-repeat;
			// background-size: 100% 100%;
			color: #62fdff;
		}
		.amap-info-close {
			font-size: 32px;
			color: $white-text-color;
			font-weight: 100;
			right: 18px;
			top: 12px;
		}
		.bottom-center .amap-info-sharp {
			border-top: 8px solid #1c4056c7;
		}
		.newcount::after {
			width: 120px;
			height: 240px;
			background-color: #bdbdbd;
		}
		.ztut {
			color: red;
		}
	}
</style>
